import { render, staticRenderFns } from "./Alfred.vue?vue&type=template&id=55f90eef&scoped=true&"
import script from "./Alfred.vue?vue&type=script&lang=js&"
export * from "./Alfred.vue?vue&type=script&lang=js&"
import style0 from "./Alfred.vue?vue&type=style&index=0&id=55f90eef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f90eef",
  null
  
)

export default component.exports